module.exports = __webpack_public_path__ + "img/digital.ab3ae1cc.png";